import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostListener,
	inject,
	Input,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { MoveToRootDirective } from '~ng-common-lib/cdk/move-to-root.directive';
import { ButtonsModule } from '~ng-common-lib/ui/buttons';

import { BaseMenu } from '../../types/menu';

@Component({
	selector: 'client-popup-menu',
	templateUrl: './popup.component.html',
	styleUrls: ['./popup.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, ButtonsModule, MoveToRootDirective],
})
export class ClientPopupMenuComponent extends BaseMenu {
	private readonly cdRef = inject(ChangeDetectorRef);

	@Input('lightBg')
	public lightBg = false;

	@Input('minHeight')
	public minHeight: string | null = null;

	private _animationFrameId: number | null = null;

	private readonly visible$$ = new BehaviorSubject(false);
	public readonly visible$ = this.visible$$.asObservable();

	public open(): void {
		this.visible$$.next(true);
		this.opened$$.next();
	}

	public close(): void {
		this.visible$$.next(false);
		this.closed$$.next();
	}

	public toggle(): void {
		if (this.visible$$.value) {
			this.close();
		} else {
			this.open();
		}
	}

	@HostListener('window:resize')
	@HostListener('window:orientationchange')
	public _onResize(): void {
		cancelAnimationFrame(this._animationFrameId!);

		this._animationFrameId = window.requestAnimationFrame(() => {
			this.cdRef.detectChanges();
		});
	}
}
